import cx from "classnames";
import { Table } from "@theorgchartdev/storybook";
import { RecordValueRow } from "@/appComponents/Blocks/Cards/RecordInfoCard/RecordValueRow";
import { RecordFieldRow } from "@/appComponents/Blocks/Cards/RecordInfoCard/RecordFieldRow";
import { RecordSourceRow } from "@/appComponents/Blocks/Cards/RecordInfoCard/RecordSourceRow";
import { appstr } from "@coreapp/utils/appstr";
import { getLocalizedTableHeaderStrings } from "@/Utils/Utils";

export const FieldsTable = props => {
  const RecordField = ({ rowState }) => {
    const data = rowState?.data;
    return <RecordFieldRow fVPair={data} delta={props.delta} />;
  };
  const RecordValue = ({ rowState }) => {
    const data = rowState?.data;
    const fieldName = data.fieldName;
    return (
      <RecordValueRow
        key={fieldName}
        onSave={props.onSave}
        delta={props.delta}
        isEditable={props.canAccessEdit}
        isEditing={props.isEditing || props.editingFields.includes(fieldName)}
        fVPair={data}
        autoFocus={props.initialEditField === fieldName}
        onEdit={props.handleStartEdit}
        onUpdate={props.onUpdateField}
        onReset={props.handleReset}
        setInitialEdit={props.setInitialEdit}
      />
    );
  };
  const RecordSource = ({ rowState }) => {
    const data = rowState?.data;
    return <RecordSourceRow fVPair={data} sourceMap={props.sourceMap} />;
  };

  let columns = [
    {
      field: "field",
      headerName: appstr("Field"),
      type: "cellRenderer",
      columnWidth: props.showSourceField ? "twenty-five" : "fifty",
      CellRenderer: RecordField,
      initSortDirection: "asc",
      overflowTextProps: {
        clamp: 2,
        colorModifier: "grey"
      }
    },
    {
      headerName: appstr("Value"),
      field: "value",
      type: "cellRenderer",
      columnWidth: props.showSourceField ? "twenty-five" : "fifty",
      filterDisabled: true,
      sortDisabled: true,
      CellRenderer: RecordValue,
      overflowTextProps: {
        clamp: 2
      }
    }
  ];

  if (props.showSourceField) {
    columns.push({
      headerName: appstr("rpdatasource"),
      field: "source",
      type: "cellRenderer",
      columnWidth: "twenty-five",
      filterDisabled: true,
      sortDisabled: true,
      CellRenderer: RecordSource,
      overflowTextProps: {
        clamp: 2
      }
    });
  }

  return (
    <div className={cx(`${props.className}-table`, "ocn-list-scrollbar")}>
      <Table
        sortEnabled
        filterEnabled
        columns={columns}
        tableLayout={"fixed"}
        rowSize="mediumR"
        textSize="smallT"
        showHeader
        data={props.data}
        headerControlProps={{
          textTags: getLocalizedTableHeaderStrings()
        }}
      />
    </div>
  );
};
